export default function LoadingSpinner() {
  return (
    <div className="test__spinner">
      <div className="test__circle">
        <div className="test__inner-circle" />
        <div className="test__inner-circle" />
        <div className="test__inner-circle" />
        <div className="test__inner-circle" />
      </div>
    </div>
  );
}
